// extracted by mini-css-extract-plugin
module.exports = {"Gallery":"Gallery_Gallery__3E08r","galleryimg":"Gallery_galleryimg__2cRrk"};